import {
    Row,
    Col,
    Typography,
    Divider,
    Card,
    Button,
    Popconfirm,
    Select
  } from "antd";
import './HomeFollowUpCards.scss';

const HomeFollowUpCards = ({dataSource,columns,onAction,...props}) => {
    const onEdit = (record) => {
        onAction({
            type: 'edit',
            data: record
        })
    }

    const onDelete = (record) => {
        onAction({
            type: 'delete',
            data: record
        })
    }
    return(
        <div className="home-followup-cards">
             <Row gutter={[10, 10]}>
                    {dataSource?.map((item, index) => (

                        <Col xs={24} sm={24} md={24} key={item.key}>
                            <Card
                                title={
                                    <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                        <div>
                                            <a
                                                style={{ color: '#235D9F', fontWeight: '400', padding: '5px 0px' }}

                                            >
                                                <span>Follow Up</span> 
                                            </a>
                                        </div>
                                    </div>
                                }
                                style={{ border: '0.5px solid #EAEAEA' }}
                                styles={{
                                    body: { padding: '0 10px 10px 10px' },
                                    head: { borderBottom: '1px solid #EAEAEA' },
                                }}
                                bordered={false}
                            >
                                <Divider style={{ margin: '0 0 5px 0', borderWidth: '2px' }} />
                                <Row gutter={24} style={{ margin: '10px',}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Created By&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <Typography.Paragraph
                                            style={{ fontWeight: '500', marginBottom: 0 }}
                                        >
                                            {item?.created_by}
                                        </Typography.Paragraph>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ margin: '10px',}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Action&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <Typography.Paragraph
                                            style={{ fontWeight: '500', marginBottom: 0, color: '#000000' }}
                                        >
                                            {item?.followup_action}
                                        </Typography.Paragraph>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ margin: '10px',}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Assigned To&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <Typography.Paragraph
                                            style={{ fontWeight: '500', marginBottom: 0, color: '#000000' }}
                                        >
                                            {item?.followup_assigned_to}
                                        </Typography.Paragraph>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ margin: '10px',}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Notes&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <Typography.Paragraph
                                            style={{ fontWeight: '500', marginBottom: 0, color: '#000000' }}
                                        >
                                            {item?.followup_notes}
                                        </Typography.Paragraph>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ margin: '10px',}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Status&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <Typography.Paragraph
                                            style={{ fontWeight: '500', marginBottom: 0, color: '#000000' }}
                                        >
                                            {item?.followup_status}
                                        </Typography.Paragraph>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ margin: '10px'}}>
                                    <Col xs={8} sm={8} md={8}>
                                        <p style={{ margin: 0, color: '#6A6D70',fontWeight: 'bolder' }}>Actions&nbsp; </p>
                                    </Col>
                                    <Col xs={16} sm={16} md={16}>
                                        <div className="action-on">
                                            <Button type="link" onClick = {() => onEdit(item)}>
                                                Edit
                                            </Button>
                                            <Popconfirm
                                                title="Delete "
                                                description="Are you sure to delete this followup?"
                                                okText="Yes"
                                                cancelText="No"
                                                onCancel={() => { }}
                                                onConfirm={() => { onDelete(item) }}
                                                getPopupContainer={() => document.body}
                                            >
                                                <Button type="link" danger>
                                                    Delete
                                                </Button>
                                            </Popconfirm>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    ))}
                </Row>
        </div>
    )
}

export default HomeFollowUpCards;